var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlStatusCompliant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gap-status-compliant__Property 1=Gap status compliant",
    className: "gap-status-compliant__Property gap-status-compliant__1=Gap gap-status-compliant__status gap-status-compliant__compliant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gap-status-compliant__\\xE2\\x9C\\xB3\\xEF\\xB8\\x8F start icon",
    className: "gap-status-compliant__\\xE2\\x9C\\xB3\\xEF\\xB8\\x8F gap-status-compliant__start gap-status-compliant__icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "gap-status-compliant__Ellipse 108",
    cx: 8,
    cy: 8,
    r: 5,
    fill: "#31BF7B",
    className: "gap-status-compliant__Ellipse gap-status-compliant__108"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlStatusCompliant);
export default __webpack_public_path__ + "static/media/control_status_compliant.70f7ed917210492c099d25f48a33de39.svg";
export { ForwardRef as ReactComponent };